import { EntityComponent } from './entity-component';
import { forwardRef } from '@angular/core';

export function provideParent
  (component: any) {
    return { provide: EntityComponent, useExisting: forwardRef(() => component) };
  }
